module.exports = __webpack_public_path__ + "media/images/lb/694-c3c93b7a63170c660f6e0f324b6bc75a.svg";